<template>
  <div class="l-content">
    <transition name="sidenav-transition" mode="out-in">
      <side-nav />
    </transition>

    <main class="l-default">
      <slot />
    </main>

    <assistance />
    <messages />
    <modals />
  </div>
</template>

<script>
import SideNav from '@/components/SideNav/SideNav'

import Assistance from '@/components/Assistance/Assistance.vue'
import Messages from '@/components/Messages/Messages.vue'
import Modals from '@/components/Modals/Modals.vue'

export default {
  name: 'Default',

  components: { SideNav, Assistance, Messages, Modals }
}
</script>
